import { render, staticRenderFns } from "./PaymentReference.vue?vue&type=template&id=47e1cf82&scoped=true"
import script from "./PaymentReference.vue?vue&type=script&lang=js"
export * from "./PaymentReference.vue?vue&type=script&lang=js"
import style0 from "./PaymentReference.vue?vue&type=style&index=0&id=47e1cf82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1cf82",
  null
  
)

export default component.exports